import { lazy } from 'react';

export const Account = lazy(() => import('./Account.component'));
